import type MockAdapter from 'axios-mock-adapter'
import { handle, parse } from './c07.shared'
import { registerMasterAreaHandlers } from './masterArea.handler'
import { registerMasterCustomerHandlers } from './masterCustomer.handler'
import { deleteEntity, setEntityStatus, usageOfEntity } from './masterData.shared'
import { registerMasterHubHandlers } from './masterHub.handler'
import { registerMasterLocationHandlers } from './masterLocation.handler'
import { registerMasterMaterialHandlers } from './masterMaterial.handler'
import { registerMasterProductHandlers } from './masterProduct.handler'
import { registerMasterSimpleHandlers } from './masterSimple.handler'

/**
 * Master Data (MST-01/03/03A/06/07/08/09/10/11) — endpoint custom `/api/v1/wms/master/*`. Endpoint umum:
 * `usage` (GET), `status` (POST: aktif/nonaktif + alasan wajib) dan `delete` (POST: hanya bila belum terpakai).
 * Endpoint per master ada di `masterSimple` (Unit, Alasan NG, SLA, Pallet), `masterProduct` (SKU FG, BOM) dan
 * `masterLocation` (Lokasi Gudang, Area); import Raw Material & Supplier ada di `masterMaterial`.
 */
export function registerMasterDataHandlers(mock: MockAdapter) {
  const base = '/api/v1/wms/master'
  mock
    .onGet(`${base}/usage`)
    .reply(config => handle(() => usageOfEntity(config.params as { entity?: string; id?: string })))
  mock.onPost(`${base}/status`).reply(config => handle(() => setEntityStatus(parse(config.data))))
  mock.onPost(`${base}/delete`).reply(config => handle(() => deleteEntity(parse(config.data))))
  registerMasterSimpleHandlers(mock)
  registerMasterProductHandlers(mock)
  registerMasterLocationHandlers(mock)
  registerMasterAreaHandlers(mock)
  registerMasterHubHandlers(mock)
  registerMasterCustomerHandlers(mock)
  registerMasterMaterialHandlers(mock)
}
